<template>
    <div
        class="apprentice-simple-card"
        v-if="loaded">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="teachers">
            <template v-slot:options>
                <div class="apprentice-group-table-actions">
                    <b-button
                        class="btn-add btn-new-group"
                        v-b-modal="'management-modules-management-add-admin'"
                        variant="primary">
                        {{ $t('management.add_administrator') }}
                    </b-button>

                    <design-2021-management-modules-management-add-admin-modal-component
                        :teachers-in="
                            teachersWithoutModule
                        "></design-2021-management-modules-management-add-admin-modal-component>
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button
                    class="btn-remove"
                    variant="danger-icon-only"
                    @click="deleteTeacher(row.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../app';

export default {
    name: 'design-2021-management-modules-management-component',
    props: ['teachersIn', 'teachersWithoutModuleIn'],
    data() {
        return {
            teachers: [],
            teachersWithoutModule: [],
            loaded: false,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        deleteTeacher(teacher) {
            this.axios.delete(this.routes.moduleManagementDeleteTeacher(teacher.id)).then(
                (response) => {
                    for (const role of teacher.roles) {
                        if (role.name === 'module') {
                            teacher.detach('roles', role.id);
                        }
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },

    mounted() {
        if (!this.loaded) {
            ords.use('user').add(this.teachersIn);

            ords.use('user')
                .where('type', '=', 'teacher')
                .with('roles', (rolesCallback) => {
                    rolesCallback.where('name', '=', 'module');
                })
                .whereHas('roles')
                .get()
                .subscribe((teachers) => {
                    this.teachers = teachers;
                });

            ords.use('user').add(this.teachersWithoutModuleIn);

            ords.use('user')
                .where('type', '=', 'teacher')
                .with('roles')
                .whereDoesntHave('roles')
                .get()
                .subscribe((teachers) => {
                    this.teachersWithoutModule = teachers;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped></style>
